// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_3c5e57e3","outerContainer":"_3c1ef264","secondaryToolbar":"_359196a9","doorHangerRight":"_21886d87","toolbarContainer":"_3581fb54","toolbarViewerMiddle":"_98cba5e5","progressBar":"_607fe905","back-to-application":"_0840ea82","wrapper":"_9490746b","resend":"_63258f37"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MfaDialog/ResendButton/index.styl
// module id = 5016
// module chunks = 39